module.exports = __webpack_public_path__ + "static/media/wizualizacja-110.66f42015.png";